/**
 * Classe responsável por buscar os certificados do usuário.
 *
 * @type {Certificate}
 */

class Certificate {

    /**
     * Método responsável por buscar o certificado no assinador(ruby).
     *
     * @param {string} cpf
     * @return {undefined}
     */
    static async getCertificatesByCpf(cpf, credentialId = '') {
        try {
            const headers = new Headers();
            headers.append('X-Requested-With', 'XMLHttpRequest');
            headers.append('Content-Type', 'application/json');
            headers.append('Accept', 'application/json');

            const complemento = credentialId ? `/credentialId/${encodeURIComponent(credentialId)}` : '';

            const result = await fetch(`/digitalsignaturegetcertificates/getandpersist/cpf/${cpf}${complemento}`, {
                method: 'GET',
                headers,
                credentials: 'same-origin'
            });

            if (result.status >= 400)
                throw new Error();

            const dados = await result.json();

            if (dados && dados.success === false) {
                throw new Error(dados.erro || 'Não foi possível obter os certificados.');
            }

            return dados;
        } catch (e) {
            throw e;
        }
    }

}
